import { render, staticRenderFns } from "./ds-manager-file-import.vue?vue&type=template&id=60982a62"
import script from "./ds-manager-file-import.vue?vue&type=script&lang=js"
export * from "./ds-manager-file-import.vue?vue&type=script&lang=js"
import style0 from "./ds-manager-file-import.vue?vue&type=style&index=0&id=60982a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports